<template>
  <li :class="{'is-active':isDropdownActive}">
    <component
      :is="componentIs"
      :to="item.to"
      :href="item.href"
      :target="item.target"
      :title="componentTitle"
      :exact-active-class="componentActiveClass"
      :class="componentClass"
      @click="menuClick"
    >
      <b-icon
        v-if="item.icon"
        class="fa"
        :class="iconClasses"
        custom-size="default"
      />
      <span
        v-if="item.label"
        :class="{'menu-item-label':!!item.icon}"
      >{{ item.label }}</span>
      <div
        v-if="hasSubmenuIcon"
        class="submenu-icon"
      >
        <b-icon
          :icon="submenuIcon"
          custom-size="default"
        />
      </div>
    </component>
    <aside-menu-list
      v-if="hasDropdown"
      :menu="item.menu"
      is-submenu-list
    />
  </li>
</template>

<script>

export default {
  name: 'AsideMenuItem',
  components: {
    AsideMenuList: () => import('@/Shared/AsideMenuList.vue'),
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isSecondary: Boolean
  },
  computed: {
    isActive() {
      if(this.item.href === '/') {
        return this.$page.url === '/';
      }
      let currentUrl = this.$page.url.substring(1);
      if(this.item.href) {
        console.log(this.item.href.substring(1));
        return currentUrl.startsWith(this.item.href.substring(1));
      }
      return false;
    },
    hasDropdown() {
      return this.item.menu;
    },
    submenuIcon() {
      return this.item.submenuIcon;
    },
    hasSubmenuIcon() {
      return this.submenuIcon;
    },
    componentIs() {
      return 'Link';
    },
    componentTitle() {
      return this.item.title;
    },
    componentActiveClass() {
      return this.item.activeClass;
    },
    componentClass() {
      let classes = [];
      if(this.isActive) {
        classes.push('is-active');
      }
      return classes;
    },
    iconClasses() {
      return 'fa fa-'+this.item.icon;
    },
    isDropdownActive() {
      return this.item.menu && this.item.menu.some(item => item.active);
    },
  },
  methods: {
    menuClick() {
      this.$emit('menu-click', this.item);
    }
  }

}
</script>
